<template>
  <div>
        
        <div class="block-content">
        

        <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
            <h3 class="font-w300 push-10">{{ sectionLabelCreateChannelTemplate[actualLanguage] }}</h3>
          
            <div class="form-group">
                <div class="col-xs-12 col-md-6">
                    <label for="register4-firstname">{{ textBoxLabelTemplateId[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="templateId" placeholder="Identifant de gabarit / Template ID">
                </div>

                <div class="col-xs-12 col-md-6">
                    <label for="register4-firstname">{{ textBoxLabelChannelName[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="channelName" placeholder="Identifant d'appareil / Device identifier">
                </div>

                <div class="col-xs-12 col-md-6">
                    <label for="register4-firstname">{{ textBoxLabelChannelType[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="channelType" placeholder="Type d'appareil / Device type">
                </div>

                <div class="col-xs-12 col-md-12">
                    <label for="register4-firstname">{{ textBoxLabelChannelDescription[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="channelDescription" placeholder="Description">
                </div>

                <div class="col-xs-12 col-md-6">
                    <label for="register4-firstname">{{ textBoxLabelIconFile[actualLanguage] }}</label>
                    <!-- ------------------------- 
                    <input class="form-control" type="text" v-model="channelIconFile" placeholder="Select">
                    -->
                    <select class="form-control" v-model=channelIconFile size="1">
                      <option v-for="picture in pictureList" v-bind:value="picture.fileName">{{picture.pictureReferenceName}}</option>
                    </select>
                </div>

                <div  class="col-xs-12 col-md-4">
                  <div class="form-group">
                    <p><img class = "img-responsive"  width="50px" :src="`organization_img/${channelIconFile}` | s3Image"></p>
                  </div>
                </div>

                <div class="col-xs-12">
                  <div class="col-sm-6 col-xs-12">
                      <label  for="example-multiple-select">{{ textBoxLabelSignalSet[actualLanguage] }}</label>
                      <select @change="resetListIndicatorsAndPanes()" class="form-control" v-model=signalSetIndex size="1">
                          <option v-for="(signalSet,indexSignalSet) in signalsSetTemplates" v-bind:value="indexSignalSet">{{signalSet.signalSetId}}</option>
                      </select>
                  </div>


                  <div class="col-sm-6 col-xs-12">
                      <label  for="example-multiple-select">{{ textBoxLabelFrontEndComponent[actualLanguage] }}</label>
                      <select class="form-control" v-model=frontendChannelComponent size="1">
                          <option value="MultiPanes_V1P00">Multi Panes version 1</option>
                      </select>
                  </div>
                </div>




            </div>


            <!-- ================================================================= -->
            <!-- Section ajout d'indicateur en format liste-->
            <!-- ================================================================= -->


            <div v-if="signalSetIndex >=0" class="block block-bordered">
              <div class="block block-themed">

              
                <div class="block-header bg-primary-dark">
                  <h3 class="font-w300 push-10 text-white-op">{{ textSectionTitleListIndicator[actualLanguage] }}</h3>
                </div>
              
                <div class="block-content">

                    <div class="form-group">

                        <div v-for="(componentListIndicator,index) in componentListIndicators" class="col-xs-12 col-md-12">


                          <div class="block block-bordered block-themed block-content">

                            <h5 class="font-w300 push-10">{{labelIndicator[actualLanguage]}}{{index+1}}</h5>
                            <div class="col-sm-12">

                              <div class="col-sm-12 col-md-6 col-lg-3">
                                <label  for="example-multiple-select">{{ labelListIndicatorVarName[actualLanguage] }}</label>
                                <select  @change="selectListIndicatorSignal(index)" class="form-control" v-model=componentListIndicator.varName size="1">
                                    <option v-for="(signal,indexSignal) in signalsSetTemplates[signalSetIndex].deviceSignals" v-bind:value="signal.signalName">{{signal.signalName}}</option>
                                </select>
                              </div>  


                              <div class="col-sm-12 col-md-6 col-lg-3">
                                <label for="register4-firstname">{{ labelListIndicatorLabelFR[actualLanguage] }}</label>
                                <input class="form-control" type="text" v-model="componentListIndicator.label.FR" placeholder="Nom/Name">
                              </div>

                              <div class="col-sm-12 col-md-6 col-lg-3">
                                <label for="register4-firstname">{{ labelListIndicatorLabelEN[actualLanguage] }}</label>
                                <input class="form-control" type="text" v-model="componentListIndicator.label.EN" placeholder="Nom/Name">
                              </div>


                              <div class="col-sm-12 col-md-6 col-lg-3">
                                <label  for="example-multiple-select">{{ labelListIndicatorAgregation[actualLanguage] }}</label>
                                <select class="form-control" v-model=componentListIndicator.agregation size="1">
                                    <option value="Sum">Somme/Sum</option>
                                    <option value="Min">Minimum</option>
                                    <option value="Max">Maximum</option>
                                    <option value="Avr">Moyenne/Average</option>
                                    <option value="Last">Dernière mesure/Last measure</option>
                                </select>
                              </div>

                            </div>

                            <div class="col-sm-12 push">

                              <div class="col-sm-12 col-md-6 col-lg-2">
                                <label  for="example-multiple-select">{{ labelTileSize[actualLanguage] }}</label>
                                <select class="form-control" v-model=componentListIndicator.width size="1">
                                      <option value="Small">Small</option>
                                      <option value="Medium">Medium</option>
                                      <option value="Large">Large</option>
                                      <option value="Full">Full</option>
                                </select>
                              </div> 

                              <div class="col-sm-12 col-md-6 col-lg-2">
                                <label  for="example-multiple-select">Decimal</label>
                                <select class="form-control" v-model=componentListIndicator.decimal size="1">
                                      <option value=0>0</option>
                                      <option value=1>1</option>
                                      <option value=2>2</option>
                                      <option value=3>3</option>
                                      <option value=4>4</option>
                                      <option value=5>5</option>
                                      <option value=6>6</option>
                                </select>
                              </div> 


                              <div class="col-sm-12 col-md-6 col-lg-3">
                                <label for="register4-firstname">{{ labelTileLabelIcon[actualLanguage] }} </label>
                                <select class="form-control" v-model=componentListIndicator.favIcon size="1">
                                    <option v-for="icon in faFavIconList" v-bind:value="icon">{{icon}}</option>
                                </select>

                              </div>
                              <div class="col-sm-12 col-md-6 col-lg-3">
                                  <label for="register4-firstname">{{ labelTileLabelIcon2[actualLanguage] }} </label>
                                  <input class="form-control" type="text" v-model="componentListIndicator.favIcon" placeholder="Variable">
                              </div>

                              <div class="col-sm-12 col-md-6 col-lg-2">
                                  <label for="register4-firstname">{{ labelIndicatorTestValue[actualLanguage] }} </label>
                                  <input class="form-control" type="text" v-model="componentListIndicator.value" placeholder="Variable">
                              </div>

                            </div>

                            <div class="col-sm-12">
                              <h5 class="font-w300 push-10">{{ labelIndicatorColorCondition[actualLanguage] }}</h5>
                            </div>

                            <div v-for="(condition,index2) in componentListIndicator.colorConditions" class="col-xs-12">

                              <div v-if= "condition.customColorFlag==false" class="col-sm-12 col-md-6 col-lg-3">
                                <label  for="example-multiple-select">{{ labelTileColor[actualLanguage] }}</label>
                                <select class="form-control" v-model=condition.colorBackground size="1">
                                      <option value="#46c37b">Vert std/Green std</option>
                                      <option value="#0000ff">Bleu/Blue</option>
                                      <option value="#00ff00">Vert/Green</option>
                                      <option value="#e1e100">Jaune/Yellow</option>
                                      <option value="#ff0000">Rouge/Red</option>
                                </select>
                              </div>

                              <div v-if= "condition.customColorFlag==false" class="col-sm-12 col-md-6 col-lg-3">
                                  <label for="register4-firstname">{{buttonSetCustomColor[actualLanguage] }}</label>
                                  <p><button @click="switchCustomColor(index,index2,true)" type="button" class="btn btn-sm btn-success" name="button">
                                    <span><i class="fa fa-pencil fa-1x push-5-r "></i></span></button></p>
                              </div>
                              

                              <div v-if= "condition.customColorFlag" class="col-sm-12 col-md-6 col-lg-3">
                                <label for="register4-firstname">{{buttonSetCustomColor[actualLanguage] }}</label>
                                  <p><input type="color" id="head" name="head"
                                        v-model:value="componentListIndicators[index].colorConditions[index2].colorBackground"></p>
                              </div>


                              <div v-if= "condition.customColorFlag" class="col-sm-12 col-md-6 col-lg-3">
                                <label for="register4-firstname">{{buttonSetCustomColor[actualLanguage] }}</label>
                                <p><button @click="switchCustomColor(index,index2,false)" type="button" class="btn btn-sm btn-success" name="button">
                                  <span><i class="fa fa-close fa-1x push-5-r "></i></span></button></p>
                              </div>
                                  
<!--
  <div class="col-sm-12 col-md-2 col-lg-3 push">
    <label  for="example-multiple-select">{{buttonRed[actualLanguage] }}</label>
    <select @change="applyCustomColor(index,index2)" class="form-control" v-model=condition.customColorRed size="1">
        <option v-for="val in 256" v-bind:value="val-1">{{val-1}}</option>
    </select>
  </div>

  <div class="col-sm-12 col-md-2 col-lg-3 push">
    <label  for="example-multiple-select">{{buttonGreen[actualLanguage] }}</label>
    <select @change="applyCustomColor(index,index2)" class="form-control" v-model=condition.customColorGreen size="1">
        <option v-for="val in 256" v-bind:value="val-1">{{val-1}}</option>
    </select>
  </div>

  <div class="col-sm-12 col-md-2 col-lg-3 push">
    <label  for="example-multiple-select">{{buttonBlue[actualLanguage] }}</label>
    <select @change="applyCustomColor(index,index2)" class="form-control" v-model=condition.customColorBlue size="1">
        <option v-for="val in 256" v-bind:value="val-1">{{val-1}}</option>
    </select>
  </div>
-->



                              <div class="col-sm-12 col-md-6 col-lg-2">
                                  <label for="register4-firstname">{{ labelIndicatorMinValue[actualLanguage] }} </label>
                                  <input class="form-control" type="text" v-model="condition.minValue" placeholder="Variable">
                              </div>
                              <div class="col-sm-12 col-md-6 col-lg-2">
                                  <label for="register4-firstname">{{ labelIndicatorMaxValue[actualLanguage] }} </label>
                                  <input class="form-control" type="text" v-model="condition.maxValue" placeholder="Variable">
                              </div>

                            </div>
                            

                            <div class="form-group">
                              <div class="col-sm-12 col-md-12 align-center">
                                <div class="col-sm-12 col-md-6">
                                    <p><button @click="addConditionalColor(index)" type="button" class="btn btn-xs btn-default push-5-r push-10" name="button">
                                      <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddColorCondition[actualLanguage] }}</span></button></p>
                                </div>   

                                <div v-if="componentListIndicator.colorConditions.length > 1" class="col-sm-12 col-md-6">
                                    <p><button @click="deleteConditionalColor(index)" type="button" class="btn btn-xs btn-default push-5-r push-10" name="button">
                                      <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteColorCondition[actualLanguage] }}</span></button></p>
                                </div>
                              </div> 
                            </div> 

                          </div>
                        </div>

                    </div>


                    <div class="form-group">
                      <div class="col-sm-12 col-md-6">
                          <p><button @click="addListIndicator()" type="button" class="btn btn-sm btn-success" name="button">
                            <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddListIndicator[actualLanguage] }}</span></button></p>
                      </div>   

                      <div v-if="componentListIndicators.length > 0" class="col-sm-12 col-md-6">
                          <p><button @click="deleteListIndicator()" type="button" class="btn btn-sm btn-danger" name="button">
                            <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteListIndicator[actualLanguage] }}</span></button></p>
                      </div> 
                    </div> 
                </div>        
              </div>
            </div>



            <div v-if="signalSetIndex >=0" class="block block-bordered block-themed block-content">
                  <div class="form-group">
                    <h3 class="font-w300 push-10 align-center">{{labelListIndicatorPreview[actualLanguage]}}</h3>
                    <api-device-list-indicator-v1p00  :componentListIndicators="componentListIndicators" ></api-device-list-indicator-v1p00>
                  </div>
            </div>




            <!-- ================================================================= -->
            <!-- Section configuration du format d'onglets (panes)-->
            <!-- ================================================================= -->
        <div v-if="signalSetIndex >=0" class="block block-bordered">
          <div class="block block-themed">

                <div class="form-group">
                  <div class="col-sm-12">
                    <div class="block-header bg-primary-dark">     
                      <h3 class="font-w300 push-10 text-white-op">{{ textSectionTitlePanes[actualLanguage] }}</h3>
                    </div>
                  </div>
                </div>


                <div class="block-content">
                    <div class="form-group"> 
                      <div v-for="(componentDetailPane,index) in componentDetailPanes" >

                        <div class="block block-bordered block-themed block-content">
                              <div class="form-group">

                                  <div class="form-group">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <h4 class="font-w300 push-10">{{ textTitlePanes[actualLanguage] }}{{index+1}}</h4>
                                    </div>

                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                      <label for="register4-firstname">{{ labelPaneButtonLabelFR[actualLanguage] }}</label>
                                      <input class="form-control" type="text" v-model="componentDetailPane.buttonLabel.FR" placeholder="Étiquette/Label">
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                      <label for="register4-firstname">{{ labelPaneButtonLabelEN[actualLanguage] }}</label>
                                      <input class="form-control" type="text" v-model="componentDetailPane.buttonLabel.EN" placeholder="Étiquette/Label">
                                    </div>

                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                      <label for="register4-firstname">{{ labelPaneTitleFR[actualLanguage] }}</label>
                                      <input class="form-control" type="text" v-model="componentDetailPane.title.FR" placeholder="Titre/Title">
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6 push">
                                      <label for="register4-firstname">{{ labelPaneTitleEN[actualLanguage] }}</label>
                                      <input class="form-control" type="text" v-model="componentDetailPane.title.EN" placeholder="Titre/Title">
                                    </div>
                                  </div>

                                    <!-- ------------------------- -->
                                    <!-- Section des tuiles-->
                                    <!-- ------------------------- -->
                                    <div class="block block-bordered block-themed block-content">
                                      <div class="form-group">
                                        <div class="col-sm-12 col-md-12 col-lg-12">
                                            <h4 class="font-w300 push-10">{{ textTileSection[actualLanguage] }}:{{index+1}}</h4>
                                        </div>

                                        <div v-for="(tile,index2) in componentDetailPane.tilesIndicator" class="col-xs-12 col-md-12">

                                          <div class="block block-bordered block-themed block-content">
                                            <div class="form-group">
                                                <h5 class="font-w300 push-10">{{ textTile[actualLanguage] }}:{{index2+1}}</h5>

                                                <div class="col-sm-12 col-md-6 col-lg-3">
                                                  <label  for="example-multiple-select">{{ labelTileVarName[actualLanguage] }}</label>
                                                  <select  @change="selectTileSignal(index,index2)" class="form-control" v-model=tile.varName size="1">
                                                      <option v-for="(signal,indexSignal) in signalsSetTemplates[signalSetIndex].deviceSignals" v-bind:value="signal.signalName">{{signal.signalName}}</option>
                                                  </select>
                                                </div>


                                                <div class="col-sm-12 col-md-6 col-lg-3">
                                                  <label for="register4-firstname">{{ labelTileLabelFR[actualLanguage] }}</label>
                                                  <input class="form-control" type="text" v-model="tile.label.FR" placeholder="Étiquette/Label">
                                                </div>

                                                <div class="col-sm-12 col-md-6 col-lg-3">
                                                  <label for="register4-firstname">{{ labelTileLabelEN[actualLanguage] }}</label>
                                                  <input class="form-control" type="text" v-model="tile.label.EN" placeholder="Étiquette/Label">
                                                </div>
                 

                                                <div class="col-sm-12 col-md-6 col-lg-3">
                                                  <label  for="example-multiple-select">{{ labelTileAgregation[actualLanguage] }}</label>
                                                  <select class="form-control" v-model=tile.agregation size="1">
                                                      <option value="Sum">Somme/Sum</option>
                                                      <option value="Min">Minimum</option>
                                                      <option value="Max">Maximum</option>
                                                      <option value="Avr">Moyenne/Average</option>
                                                  </select>
                                                </div> 





                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                  <div class="col-sm-12">
                                                    <label  for="example-multiple-select">{{ labelTileColor[actualLanguage] }}</label>
                                                    <select class="form-control" v-model=tile.colorBackground size="1">
                                                      <option value="bg-primary">Bleu/Blue</option>
                                                      <option value="bg-success">Vert/Green</option>
                                                      <option value="bg-danger">Rouge/Red</option>
                                                      <option value="bg-primary-dark">Foncé/Dark</option>
                                                      <option value="bg-modern">Bleu pale/Light Blue</option>
                                                      <option value="bg-amethyst">Violet/Purple</option>
                                                      <option value="bg-city">Rouge Pale/Light Red</option>

                                                    </select>
                                                  </div> 

                                                  <div class="col-sm-12 col-md-6">
                                                    <label for="register4-firstname">{{ labelTileValueSufix[actualLanguage] }} </label>
                                                    <input class="form-control" type="text" v-model="tile.valueSufix" placeholder="$, %, C ...">
                                                  </div> 

                                                  <div class="col-sm-12 col-md-6">
                                                    <label  for="example-multiple-select">Decimal</label>
                                                    <select class="form-control" v-model=tile.decimal size="1">
                                                          <option value=0>0</option>
                                                          <option value=1>1</option>
                                                          <option value=2>2</option>
                                                          <option value=3>3</option>
                                                          <option value=4>4</option>
                                                          <option value=5>5</option>
                                                          <option value=6>6</option>
                                                    </select>
                                                  </div> 


                                                </div> 



                                                <div class="col-sm-12 col-md-6 col-lg-6 push">
                                                  <label for="register4-firstname">{{ labelTileLabelIcon[actualLanguage] }} </label>
                                                  <select class="form-control" v-model=tile.favIcon size="1">
                                                      <option v-for="icon in faFavIconList" v-bind:value="icon">{{icon}}</option>
                                                  </select>
                                                  <label for="register4-firstname">{{ labelTileLabelIcon2[actualLanguage] }} </label>
                                                  <input class="form-control" type="text" v-model="tile.favIcon" placeholder="Variable">
                                                </div>

                                              </div>
                                            </div>
                                          </div>

                                        <div class="col-sm-12 col-md-6">
                                            <p><button @click="addTile(index)" type="button" class="btn btn-sm btn-success" name="button">
                                              <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddTile[actualLanguage] }}</span></button></p>
                                        </div>   

                                        <div v-if="componentDetailPane.tilesIndicator.length > 0" class="col-sm-12 col-md-6">
                                            <p><button @click="deleteLastTile(index)" type="button" class="btn btn-sm btn-danger" name="button">
                                              <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteLastTile[actualLanguage] }}</span></button></p>
                                        </div>
                                      </div>
                                    </div>
                                    


                                    <!-- ------------------------- -->
                                    <!-- Section des graphs-->
                                    <!-- ------------------------- -->
                                    <div class="block block-bordered block-themed block-content">
                                      <div class="form-group">
                                        <div class="col-sm-12 col-md-12 col-lg-12">
                                            <h4 class="font-w300 push-10">{{ textGraphsSection[actualLanguage] }}:{{index+1}}</h4>
                                        </div>

                                        <div v-for="(graph,index3) in componentDetailPane.graphs" class="col-xs-12 col-md-12">

                                          <div class="block block-bordered block-themed block-content">
                                            <div class="form-group">
                                                <h5 class="font-w300 push-10">{{ textGraph[actualLanguage] }}:{{index3+1}}</h5>
                                                <div class="col-sm-12 col-md-12 col-lg-12 push">
                                                  <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <label for="register4-firstname">{{ labelGraphTitleFR[actualLanguage] }}:{{index3+1}}</label>
                                                    <input class="form-control" type="text" v-model="graph.title.FR" placeholder="Étiquette/Label">
                                                  </div>

                                                  <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <label for="register4-firstname">{{ labelGraphTitleEN[actualLanguage] }}:{{index3+1}}</label>
                                                    <input class="form-control" type="text" v-model="graph.title.EN" placeholder="Étiquette/Label">
                                                  </div>

                                                  <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <label  for="example-multiple-select">Type</label>
                                                    <select class="form-control" v-model=graph.type size="1">
                                                        <option value="LineSingle">Ligne simple / Line single</option>
                                                        <option value="LineMultiple">Ligne multiples / Line multiple</option>
                                                        <option value="BarSingle">Barre simple / Bar single</option>
                                                        <option value="BarMultiple">Barre multiples / Bar multiple</option>
                                                    </select>
                                                  </div> 
                                                </div>


                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                    <h5 class="font-w300 push-10">{{ textGraphTraceSection[actualLanguage] }}:{{index3+1}}</h5>
                                                </div>

                                                <div v-for="(trace,index4) in graph.traces" class="col-xs-12 col-md-12">

                                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                                        <h5 class="font-w300 push-10">Trace:{{index4+1}}</h5>
                                                    </div> 


                                                    <div class="col-sm-12 col-md-6 col-lg-3">
                                                      <label  for="example-multiple-select">{{ labelTileVarName[actualLanguage] }}</label>
                                                      <select  @change="selectGraphTraceSignal(index,index3,index4)" class="form-control" v-model=trace.yVarName size="1">
                                                          <option v-for="(signal,indexSignal) in signalsSetTemplates[signalSetIndex].deviceSignals" v-bind:value="signal.signalName">{{signal.signalName}}</option>
                                                      </select>
                                                    </div>


                                                    <div class="col-sm-12 col-md-6 col-lg-3">
                                                      <label for="register4-firstname">{{ labelGraphTraceFR[actualLanguage] }}</label>
                                                      <input class="form-control" type="text" v-model="trace.label.FR" placeholder="Étiquette/Label">
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 col-lg-3">
                                                      <label for="register4-firstname">{{ labelGraphTraceEN[actualLanguage] }}</label>
                                                      <input class="form-control" type="text" v-model="trace.label.EN" placeholder="Étiquette/Label">
                                                    </div>


                                                    <div class="col-sm-12 col-md-6 col-lg-3 push">
                                                      <label  for="example-multiple-select">{{labelHrDayTraces[actualLanguage] }}</label>
                                                      <select class="form-control" v-model=trace.hourDayTraces size="4" multiple>
                                                          <option value="Min">Min</option>
                                                          <option value="Max">Max</option>
                                                          <option value="Avr">Moyenne/Average</option>
                                                          <option value="Sum">Sum</option>
                                                      </select>
                                                    </div>

                                                </div>

                                                <div class="col-sm-12 col-md-6">
                                                    <p><button @click="addGraphTrace(index,index3)" type="button" class="btn btn-sm btn-success" name="button">
                                                      <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddGraphTrace[actualLanguage] }}</span></button></p>
                                                </div>   

                                                <div v-if="componentDetailPane.graphs.length > 0" class="col-sm-12 col-md-6">
                                                    <p><button @click="deleteLastGraphTrace(index,index3)" type="button" class="btn btn-sm btn-danger" name="button">
                                                      <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteLastGraphTrace[actualLanguage] }}</span></button></p>
                                                </div> 
                                              </div>
                                            </div>

                                        </div>

                                        <div class="col-sm-12 col-md-6">
                                            <p><button @click="addGraph(index)" type="button" class="btn btn-sm btn-success" name="button">
                                              <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddGraph[actualLanguage] }}</span></button></p>
                                        </div>   

                                        <div v-if="componentDetailPane.graphs.length > 0" class="col-sm-12 col-md-6">
                                            <p><button @click="deleteLastGraph(index)" type="button" class="btn btn-sm btn-danger" name="button">
                                              <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteLastGraph[actualLanguage] }}</span></button></p>
                                        </div>
                                      </div> 
                                    </div>
                            </div>       
                      </div>                     
                    </div>

                    <div class="form-group">
                      <div class="col-sm-12 col-md-6">
                          <p><button @click="addPane()" type="button" class="btn btn-md btn-success" name="button">
                            <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddPane[actualLanguage] }}</span></button></p>
                      </div>   

                      <div v-if="componentDetailPanes.length > 0" class="col-sm-12 col-md-6">
                          <p><button @click="deleteLastPane()" type="button" class="btn btn-md btn-danger" name="button">
                            <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteLastPane[actualLanguage] }}</span></button></p>
                      </div> 
                    </div> 
                  </div>

            </div>        
          </div>
        </div>


        <div v-if="signalSetIndex >=0" class="block block-bordered block-themed block-content">
          <div class="form-group">
              <div class="col-sm-12 col-md-12">
                <h3 class="font-w300 push-10 align-center">{{labePanePreview[actualLanguage]}}</h3>
              </div>

              <div v-if="componentDetailPanes.length > 0" class="col-sm-12 col-md-12 align-center">
                  <p><button @click="refreshPane()" type="button" class="btn btn-sm btn-default" name="button">
                    <span><i class="fa fa-repeat pull-left"></i>{{ labelButtonPaneRefresh[actualLanguage] }}</span></button></p>
              </div> 

              <div v-if="flagDisplayPreview" class="col-sm-12 col-md-12">
                  <api-device-panes-v1p00  :panes="componentDetailPanes" ></api-device-panes-v1p00>
              </div>
          </div>
        </div>


            <div class="form-group">
              <div v-if="componentDetailPanes.length > 0 & componentListIndicators.length > 0" class="col-sm-12 col-md-12">

                <div class="col-sm-12 col-md-12 col-lg-12 push">
                  <label for="register4-firstname">{{ labelSelectApiKey[actualLanguage] }} </label>
                  <select class="form-control" v-model=selectedApiKey size="1">
                      <option v-for="key in overlayParameters.organizationApiKeys" v-bind:value="key.key">{{key.referenceName}} : {{key.key}}</option>
                  </select>

                </div>


                <div v-if="selectedApiKey.length > 0">
                    <p><button @click="saveChannelTemplate()" type="button" class="btn btn-block btn-success" name="button">
                      <spinner size="small" v-if="templateIsCreating"></spinner>
                      <span v-else><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonLabelSave[actualLanguage] }}</span></button></p>
                </div> 
              </div>
            </div>
          

          </form>
        </div>



  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import ApiDeviceListIndicatorV1p00 from '../measurements/SubComponents/ApiDeviceListIndicatorV1p00.vue'
import ApiDevicePanesV1p00 from '../measurements/SubComponents/ApiDevicePanesV1p00.vue'
import _ from 'underscore'
export default {
  name: 'AddOrganizationForm',
  components: {
    Spinner,
    ApiDeviceListIndicatorV1p00,
    ApiDevicePanesV1p00
  },
  data() {
    return {
      errorMsg: '',
      templateIsCreating: false,
      actualLanguage : "FR",

      sectionLabelCreateChannelTemplate:{FR: "Gabarit d'affichage des appareils (channel)", EN: 'Channel display templates'},

      textBoxLabelTemplateId:{FR: "Identifiant du gabarit d'affichage des appareils", EN: 'Channel display templates ID'},
      templateId : "",

      textBoxLabelChannelName:{FR: "Identifiant de l'appareil (channel)", EN: 'Device identifier'},
      channelName : "",

      textBoxLabelChannelType:{FR: "Type d'appareil", EN: 'Device type'},
      channelType : "",

      textBoxLabelChannelDescription:{FR: "Description d'appareil", EN: 'Device description'},
      channelDescription : "",

      textBoxLabelIconFile:{FR: "Image d'appareil", EN: 'Device picture'},
      channelIconFile : "",
      pictureList : [],

      textBoxLabelSignalSet:{FR: "Ensemble de signaux", EN: 'Signal set'},
      signalsSetTemplates : [],
      signalSetIndex : -1,

      selectedApiKey : "",

      //------------------------------------------
      //Section List indicators
      //------------------------------------------
      textBoxLabelFrontEndComponent:{FR: "Composante d'affichage du portail", EN: 'Web portal display component'},
      frontendChannelComponent : "MultiPanes_V1P00",

      textSectionTitleListIndicator:{FR: "Indicateur en format liste", EN: "Indicator in list format"},
      componentListIndicators : [],
      labelListIndicatorLabelFR:{FR: "Étiquette affichée (FR)", EN: "Displayed label (FR)"},
      labelListIndicatorLabelEN:{FR: "Étiquette affichée (EN)", EN: "Displayed label (EN)"},
      labelListIndicatorVarName:{FR: "Variable (signal)", EN: "Variable (signal)"},
      labelListIndicatorAgregation:{FR: "Type agrégation", EN: "Agregation type"},

      buttonDeleteListIndicator:{FR: "Supprimer dernière indicateur", EN: 'Deleta last indicator'},
      buttonAddListIndicator:{FR: "Ajouter un indicateur", EN: 'Add indicator'},

      buttonLabelSave:{FR: "Créer/Modifier le gabarit", EN: 'Create/Modify the template'},
      labelSelectApiKey:{FR: "L'enregistrement d'un gabarit requiert une clef d'API maître, vous devez en sélectionné une:", EN: 'Template saving require a master API key, select one:'},
      messageProfileRefreshAction:{FR: "Le gabarit a été créé dans le système, cette opération requiert un rafraichissement des données de votre organisation (fait automatiquement).",
                                   EN: 'The template was created in the system, this action require an organization data refresh (done automatically).'},

      labelIndicator:{FR: "Indicateur:", EN: 'Indicator:'},
      labelIndicatorTestValue:{FR: "Valeur test", EN: 'Test value'},
      flagDisplayConditions : true,
      labelIndicatorColorCondition:{FR: "Couleurs conditionelles", EN: 'Conditional color'},
      labelIndicatorMinValue:{FR: "Valeur min", EN: 'Min value'},
      labelIndicatorMaxValue:{FR: "Valeur max", EN: 'Max value'},
      buttonSetCustomColor:{FR: "Couleur personalisée", EN: 'Personalized color'},
      buttonRed:{FR: "Rouge", EN: 'Red'},
      buttonGreen:{FR: "Vert", EN: 'Green'},
      buttonBlue:{FR: "Bleu", EN: 'Blue'},


      buttonAddColorCondition:{FR: "Ajouter une couleur conditionelle", EN: 'Add conditionnal color'},
      buttonDeleteColorCondition:{FR: "Supprimer dernière condition", EN: 'Delete last condition'},

      labelListIndicatorPreview:{FR: "Preview affichage format liste", EN: 'List display preview'},

      //------------------------------------------
      //Section Graphic panes
      //------------------------------------------
      textSectionTitlePanes:{FR: "Onglets en format detail", EN: "Detail tabs"},
      textTitlePanes:{FR: "Onglets (pane):", EN: "Tabs (pane):"},
      componentDetailPanes : [],

      labelPaneButtonLabelFR:{FR: "Étiquette bouton sélection (FR)", EN: "Selection button label (FR)"},
      labelPaneButtonLabelEN:{FR: "Étiquette bouton sélection (EN)", EN: "Selection button label (EN)"},

      labelPaneTitleFR:{FR: "Titre de l'onglet (FR)", EN: "Tab title (FR)"},
      labelPaneTitleEN:{FR: "Titre de l'onglet (EN)", EN: "Tab title(EN)"},

      buttonAddPane :{FR: "Ajouter onglet", EN: 'Add tab'},
      buttonDeleteLastPane :{FR: "Supprimer dernière onglet", EN: 'Deleta last tabs'},

      labePanePreview:{FR: "Preview affichage en detail", EN: 'Detail view preview'},
      labelButtonPaneRefresh:{FR: "Rafraichir", EN: 'Refresh'},
      flagDisplayPreview : true,



      //---------------------
      //Tiles section
      //---------------------
      textTile:{FR: "Tuile", EN: "Tile"},
      textTileSection:{FR: "Tuiles de l'onglet", EN: "Tab tiles"},
      labelTileLabelFR:{FR: "Étiquette affichée (FR)", EN: "Displayed label (FR)"},
      labelTileLabelEN:{FR: "Étiquette affichée (EN)", EN: "Displayed label (EN)"},
      labelTileLabelIcon:{FR: "Icône (fa fav icon)", EN: "Icon (fa fav icon)"},
      labelTileValueSufix:{FR: "Sufixe de la valeur", EN: "Value sufix"},
      labelTileLabelIcon2:{FR: "Icône (entrée manuelle)", EN: "Icon (manual entry)"},
      labelTileVarName:{FR: "Variable (signal)", EN: "Variable (signal)"},
      labelTileColor:{FR: "Couleur prédéfinie", EN: "Predefined color"},
      labelTileSize:{FR: "Dimension", EN: "Width"},
      labelTileAgregation:{FR: "Type d'agrégation", EN: "Agregation type"},
      faFavIconList : ["fa fa-adjust","fa fa-align-justify","fa fa-anchor","fa fa-android","fa fa-angle-double-down","fa fa-angle-double-left","fa fa-angle-double-right","fa fa-angle-double-up","fa fa-archive","fa fa-area-chart","fa fa-arrow-circle-down","fa fa-arrow-circle-left","fa fa-arrow-circle-right","fa fa-arrow-circle-up","fa fa-arrow-circle-up","fa fa-arrows-h","fa fa-arrows-v","fa fa-arrows","fa fa-asterisk","fa fa-automobile","fa fa-bar-chart","fa fa-bars","fa fa-bathtub","fa fa-battery-1","fa fa-battery-2","fa fa-battery-3","fa fa-battery-4","fa fa-bell","fa fa-bolt","fa fa-building-o","fa fa-bus","fa fa-cab","fa fa-calendar-o","fa fa-chain","fa fa-child","fa fa-cloud","fa fa-cogs","fa fa-cubes","fa fa-database","fafa-desktop","fa fa-eject","fa fa-file","fa fa-files-o","fa fa-free-code-camp","fa fa-gear","fa fa-gears","fa fa-home","fa fa-leaf","fa fa-money","fa fa-plug","fa fa-server","fa fa-signal","fa fa-sort-amount-asc","fa fa-sort-amount-desc","fa fa-spinner","fa fa-tachometer","fa fa-thermometer","fa fa-thumbs-o-down","fa fa-thumbs-o-up","fa fa-tint","fa fa-trash","fa fa-tree","fa fa-volume-up","fa fa-upload"],
    
      buttonAddTile :{FR: "Ajouter tuile", EN: 'Add tile'},
      buttonDeleteLastTile :{FR: "Supprimer dernière tuile", EN: 'Deleta last tile'},
      

      //---------------------
      //Graph section
      //---------------------
      textGraph:{FR: "Graphiques", EN: "Graph"},
      textGraphsSection:{FR: "Graphiques de l'onglet", EN: "Tab graph"},
      labelGraphTitleFR:{FR: "Titre du graphique (FR)", EN: "Graph title (FR)"},
      labelGraphTitleEN:{FR: "Titre du graphique (EN)", EN: "Graph title (EN)"},


      textGraphTraceSection:{FR: "Traces du graphique", EN: "Graph traces"},
      buttonAddGraphTrace :{FR: "Ajouter une trace", EN: 'Add trace'},
      labelGraphTraceFR:{FR: "Étiquette (FR)", EN: "Label (FR)"},
      labelGraphTraceEN:{FR: "Étiquette (EN)", EN: "Label (EN)"},
      labelGraphTraveVarName:{FR: "Variable (signal)", EN: "Variable (signal)"},
      labelHrDayTraces:{FR: "Traces (Heure/Jour)", EN: "Traces (Hour/Day)"},

      buttonDeleteLastGraphTrace :{FR: "Supprimer dernière trace", EN: 'Deleta last trace'},

      buttonAddGraph :{FR: "Ajouter un graphique", EN: 'Add one graph'},
      buttonDeleteLastGraph :{FR: "Supprimer dernièr graphique", EN: 'Deleta last graph'},




    }
  },

  methods: {

    addListIndicator(){
      this.componentListIndicators.push({
        label:{FR:"",EN:""},
        favIcon:"",
        varName:"",
        width:"Small",
        value:Math.floor(Math.random()*10),
        agregation:"Sum",
        decimal:"2",
        colorConditions : [{colorBackground : "#46c37b",
                            minValue:-100000,
                            maxValue:100000,
                            customColorFlag:false,
                            customColorRed:125,
                            customColorGreen:125,
                            customColorBlue:125}]
      })
    },
    deleteListIndicator(){
      this.componentListIndicators.pop()
    },

    addConditionalColor(index){
      this.componentListIndicators[index].colorConditions.push({
                            colorBackground : "#46c37b",
                            minValue:-100000,
                            maxValue:100000,
                            customColorFlag:false,
                            customColorRed:125,
                            customColorGreen:125,
                            customColorBlue:125
      })
    },

    resetListIndicatorsAndPanes(){
      this.componentListIndicators = []
      this.componentDetailPanes = []

    },

    selectListIndicatorSignal(indicatorIndex){
        for (var n = 0; n < this.signalsSetTemplates[this.signalSetIndex].deviceSignals.length; n++){
          if(this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalName == this.componentListIndicators[indicatorIndex].varName){
            this.componentListIndicators[indicatorIndex].label.FR = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.FR
            this.componentListIndicators[indicatorIndex].label.EN = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.EN
            }
        }
    },

    switchCustomColor(index1, index2,value){
        this.componentListIndicators[index1].colorConditions[index2].customColorFlag = value
        this.applyCustomColor(index1,index2)
        //this.flagDisplayConditions = false
        //this.$nextTick(() => {this.flagDisplayConditions = true});
    },
    applyCustomColor(index1,index2){
        var RED = this.componentListIndicators[index1].colorConditions[index2].customColorRed
        var GREEN = this.componentListIndicators[index1].colorConditions[index2].customColorGreen
        var BLUE = this.componentListIndicators[index1].colorConditions[index2].customColorBlue
        this.componentListIndicators[index1].colorConditions[index2].colorBackground = this.convertRGBtoHex(RED,GREEN,BLUE)
    },

    deleteConditionalColor(index){
      this.componentListIndicators[index].colorConditions.pop()
    },


    addPane(){
      this.componentDetailPanes.push({
        buttonLabel:{FR:"Onglet",EN:"Tab"},
        title:{FR:"Nouvel onglet",EN:"New tab"},
        tilesIndicator:[],
        graphs:[],
      })
    },
    deleteLastPane(){
      this.componentDetailPanes.pop()
    },
    refreshPane(){
      this.flagDisplayPreview = false
      this.$nextTick(() => {this.flagDisplayPreview = true});      
    },

    addTile(index){
      this.componentDetailPanes[index].tilesIndicator.push({
        label:{FR:"Étiquette FR",EN:"Label EN"},
        valueSufix : "",
        varName:"",
        decimal:"2",
        value:Math.floor(Math.random()*10),
        agregation:"Sum",
        favIcon:"fa fa-tachometer",
        colorBackground : "bg-success",
      })
    },

    selectTileSignal(paneIndex,tileIndex){
        for (var n = 0; n < this.signalsSetTemplates[this.signalSetIndex].deviceSignals.length; n++){
          if(this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalName == this.componentDetailPanes[paneIndex].tilesIndicator[tileIndex].varName){
            this.componentDetailPanes[paneIndex].tilesIndicator[tileIndex].label.FR = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.FR
            this.componentDetailPanes[paneIndex].tilesIndicator[tileIndex].label.EN = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.EN
            }
        }
    },



    deleteLastTile(index){
      this.componentDetailPanes[index].tilesIndicator.pop()
    },


    addGraph(index){
      this.componentDetailPanes[index].graphs.push({
        title:{FR:"Titre FR",EN:"Title EN"},
        type : "LineSingle",
        xLabel:{FR:"Time FR",EN:"Title X EN"},
        xData:['2022-01-01 01:00:00','2022-01-01 01:10:00','2022-01-01 01:20:00','2022-01-01 01:30:00','2022-01-01 01:40:00'],
        xVarName:"DateTime",
        traces : [],
      })
    },
    deleteLastGraph(index){
      this.componentDetailPanes[index].graphs.pop()
    },

    addGraphTrace(index,index2){
      this.componentDetailPanes[index].graphs[index2].traces.push({
        label:{FR:"Étiquette FR",EN:"Label EN"},
        yVarName:"",
        yData:[Math.floor(Math.random()*10),Math.floor(Math.random()*10),Math.floor(Math.random()*10),Math.floor(Math.random()*10),Math.floor(Math.random()*10)],
        hourDayTraces : [],
      })
    },


    selectGraphTraceSignal(paneIndex,graphIndex,traceIndex){
        for (var n = 0; n < this.signalsSetTemplates[this.signalSetIndex].deviceSignals.length; n++){
          if(this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalName == this.componentDetailPanes[paneIndex].graphs[graphIndex].traces[traceIndex].yVarName){
            this.componentDetailPanes[paneIndex].graphs[graphIndex].traces[traceIndex].label.FR = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.FR
            this.componentDetailPanes[paneIndex].graphs[graphIndex].traces[traceIndex].label.EN = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.EN
            }
        }
    },


    deleteLastGraphTrace(index,index2){
      this.componentDetailPanes[index].graphs[index2].traces.pop()
    },


    getSignalSetList(){
      this.channelTemplates = []
        var requestData = { 'postAction':'GetOrganizationSignalsSet',
                            'organizationId': this.overlayParameters.organizationId,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              
            if(response.data.Code=='OK'){
                //this.createNewApiMasterKey = false
                this.signalsSetTemplates = response.data.SignalsSets
                //console.log('----Get Signal List-----')
                //console.log(this.signalsSetTemplates)

                if (this.overlayParameters.action == 'edit'){
                    this.getChannelTemplate()
                }

                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  
    },



    saveChannelTemplate() {
      this.keyIsCreating = true

      var updateAllChannelFlag = false
      var confirmMessage = {FR:"Mettre a jour tous les appareils créés avec ce gabarit? (OUI = OK, NON=ANNULER)",
                            EN:"Update all device created with this template? (YES = OK, NO=CANCEL)"}
      if(this.overlayParameters.action=='edit'){
        updateAllChannelFlag = window.confirm(confirmMessage[this.actualLanguage])
      }


      var postBody = {
        'postAction':'createChannelTemplate',
        'postSubAction':this.overlayParameters.action,
        'updateAllChannelFlag':updateAllChannelFlag,
        'organization_id':this.overlayParameters.organizationId.substring(5,20),
        'template_id':this.templateId,
        'channelName':this.channelName,
        'channelType':this.channelType,
        'channelDescription':this.channelDescription,
        'iconFile':this.channelIconFile,
        'signalSetId':this.signalsSetTemplates[this.signalSetIndex].signalSetId,
        'frontEndChannelComponent':this.frontendChannelComponent,
        'componentListIndicators':this.componentListIndicators,
        'componentDetailPanes':this.componentDetailPanes,
      }



      var requestData = { 'postAction':'ApiCustomerGateway',
                          'organizationId': this.overlayParameters.organizationId,
                          'organizationApiKey': this.selectedApiKey,
                          'postBody':postBody ,
                        }

      this.templateIsCreating = true
      this.$store.dispatch('sessionStore/postOrganization', requestData)
          .then((response) => {
            //console.log('--------------------------')
            //console.log(response.data)
            this.templateIsCreating  = false
          if(response.data.Code=='OK'){
              window.alert(this.messageProfileRefreshAction[this.actualLanguage])
              this.$store.dispatch('sessionStore/refreshProfileData')
              this.$store.dispatch('overlayStore/toggleModal',false)
              }
              else{ window.alert(response.data.CallResponse.message)}
          })       
      },


    getChannelTemplate(){
      this.channelTemplates = []
        var requestData = { 'postAction':'GetOrganizationSingleChannelTemplate',
                            'organizationId': this.overlayParameters.organizationId,
                            'templateId': this.overlayParameters.templateId,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log('----Get Channel Template-----')
              //console.log(response.data)
              
            if(response.data.Code=='OK'){
                this.templateId = this.overlayParameters.templateId
                this.channelName = response.data.ChannelTemplate.channelInfo.channelName
                this.channelType = response.data.ChannelTemplate.channelInfo.channelType
                this.channelDescription = response.data.ChannelTemplate.channelInfo.channelDescription
                this.channelIconFile = response.data.ChannelTemplate.channelInfo.iconFile
                this.frontendChannelComponent = response.data.ChannelTemplate.channelInfo.channelComponent

                this.componentListIndicators = response.data.ChannelTemplate.channelComponentData.listIndicators
                this.componentDetailPanes = response.data.ChannelTemplate.channelComponentData.detailPanes

                //We have to identify the index of the signalSetId into the loaded signalsSetsList
                //console.log("signalSet ID:")
                //console.log(response.data.ChannelTemplate.signalSetId)
                for (var n = 0; n < this.signalsSetTemplates.length; n++){
                  if(this.signalsSetTemplates[n].signalSetId == response.data.ChannelTemplate.signalSetId){
                    this.signalSetIndex = n
                    }
                }



                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  


    },



    getPictureList(){
      this.pictureList = []
        var requestData = { 'postAction':'GetOrganizationPictureList',
                            'organizationId': this.overlayParameters.organizationId,
                            'pictureType': 'channel',
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                this.pictureList = response.data.PictureList
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  

    },


    colorToHex(color){
      var hexadecimal = color.toString(16);
      return hexadecimal.length == 1 ? "0" + hexadecimal : hexadecimal;
    },

    convertRGBtoHex(red, green, blue) {
      return "#" + this.colorToHex(red) + this.colorToHex(green) + this.colorToHex(blue);
    }
  
  },

  computed: {
    ...mapState('sessionStore', ['profileData']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //console.log('-----Profile Data----')
    //console.log(this.profileData)
    //console.log(Math.floor(Math.random()*10))
    //console.log(this.convertRGBtoHex(225, 225, 0))
    this.getPictureList()
    this.getSignalSetList() //This function call this.getChannelTemplate() if the this.overlayParameters.action == 'edit'

  }


}
</script>



// WEBPACK FOOTER //
// OrganizationApiChannelTemplateAddForm.vue?3b71f0c3